import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters";
import { ProductMapperParameter, ProductFactory } from "@/v2/models/products.js";
import { WarehouseFactory, WarehouseMapperParameter } from "@/v2/models/warehouses.js";

export class WarehouseInventory extends DataObject {
    _type = "warehouse_inventory";

    id;
    batch_id;
    branch_id; // warehouse_id
    balance;
    physical_balance;
    sellable_balance;
    product_id;
    product_parent_id;
    conv_rate_group;
    product;
    stock_balance;
    stock_balance_id;
    warehouse;
    product_type;
    is_matrix_product;
    created_at;
    updated_at;
    deleted_at;
}

export class WarehouseInventoryMapperParameter extends Parameter {
    warehouseInventoryMapper;
    productMapperParameter = new ProductMapperParameter();
    warehouseMapperParameter = new WarehouseMapperParameter();
}

export class WarehouseInventoryFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {WarehouseInventoryMapperParameter} warehouseInventoryMapperParameter Parameter object containing mappers that the factory expects.
     * @param {Object, null} data Data to construct the WarehouseInventory object with.
     * @returns {WarehouseInventory}
     */
    static construct(warehouseInventoryMapperParameter, data = null) {
        if (data != null) {
            let warehouseInventory = DataObjectFactory.getInstance().construct(
                WarehouseInventory,
                data ? warehouseInventoryMapperParameter.warehouseInventoryMapper(data) : null
            );

            if (data.product) {
                warehouseInventory.product = ProductFactory.construct(
                    warehouseInventoryMapperParameter.productMapperParameter,
                    data.product
                );
            }

            if (data.warehouse) {
                warehouseInventory.warehouse = WarehouseFactory.construct(
                    warehouseInventoryMapperParameter.warehouseMapperParameter,
                    data.warehouse
                );
            }
            return warehouseInventory;
        }

        return null;
    }
}
